import { Form } from 'antd';
import { useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { usePurchaseOrderStatusChangeMutation } from 'api';

interface UseShippingEditProps {
  onCancelModal: () => void;
}

export const useConfirmOrder = (props: UseShippingEditProps) => {
  const { onCancelModal } = props;
  const [form] = Form.useForm();
  const { id } = useParams() as { id: string };
  const { handleSuccess, handleError } = useNotificationMessages();

  const [updatePurchaseOrderStatus, { isLoading: isLoadingUpdate }] = usePurchaseOrderStatusChangeMutation();

  const onCancel = useCallback(() => {
    form.resetFields();
    onCancelModal();
  }, [form, onCancelModal]);

  const onFinish = useCallback(async () => {
    try {
      const payload = form.getFieldsValue() || {};
      payload.id = id as string;
      payload.status = 'ORDER_CONFIRMED';
      const { data, error }: Record<string, any> = await updatePurchaseOrderStatus(payload);
      if (data?.success) {
        handleSuccess('Purchase Order status was successfully updated.');
        onCancel();
      } else {
        handleError(error);
      }
    } catch (err) {
      handleError(err);
    }
  }, [updatePurchaseOrderStatus, handleSuccess, handleError, id, onCancel, form]);

  return {
    form,
    isLoadingUpdate,
    onFinish,
    onCancel,
  };
};
